var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"screen-main"},[_c('div',{staticClass:"screen-main-container"},[_c('keep-alive',[(_vm.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),(!_vm.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }